import { render, staticRenderFns } from "./PurchaseSchedule.vue?vue&type=template&id=0bdd890d&"
import script from "./PurchaseSchedule.vue?vue&type=script&lang=js&"
export * from "./PurchaseSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports